<template>
    <div>
        <!-- Container dos ícones sociais -->
        <div class="nav-social">
            <div class="social-item" v-for="item in socialItems" :key="item.name">
                <a v-if="item.name === 'login'" href="#" @click.prevent="openLogin" target="_self">
                    <img :src="item.icon" :alt="item.name" />
                </a>
                <a v-else :href="item.link" target="_blank" rel="noopener noreferrer">
                    <img :src="item.icon" :alt="item.name" />
                </a>
            </div>
        </div>
        
        <!-- Modal de Login usando Teleport para fora da hierarquia do componente -->
        <Teleport to="body">
            <div v-if="loginDialog" class="login-overlay" @click.self="closeLogin">
                <div class="login-modal">
                    <div class="login-header">
                        <h3>Acesso ao Sistema</h3>
                        <button class="close-btn" @click="closeLogin">&times;</button>
                    </div>
                    <div class="login-content">
                        <form @submit.prevent="handleLogin">
                            <div class="form-group">
                                <input 
                                    v-model="loginData.login" 
                                    type="text" 
                                    placeholder="Login" 
                                    required
                                    autocomplete="username"
                                    ref="usernameInput"
                                />
                            </div>
                            <div class="form-group">
                                <input 
                                    v-model="loginData.password" 
                                    type="password" 
                                    placeholder="Senha" 
                                    required 
                                    autocomplete="current-password"
                                />
                            </div>
                            <button type="submit" class="btn-login" :disabled="loading">
                                {{ loading ? 'Entrando...' : 'Entrar' }}
                            </button>
                            <div class="form-group align-center">
                                <span class="forgot-password"><a href="https://dashboard.axesis.com.br/forgotPassword">Esqueci minha senha</a></span>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </Teleport>
    </div>
</template>

<script>
export default {
    name: 'NavSocial',
    data() {
        return {
            loginDialog: false,
            loading: false,
            loginData: {
                login: '',
                password: ''
            },
            socialItems: [
                { 
                    name: 'Facebook', 
                    link: 'https://www.facebook.com/temploedem', 
                    icon: require('@/assets/facebook.png') 
                },
                { 
                    name: 'Instagram', 
                    link: 'https://www.instagram.com/temploedem', 
                    icon: require('@/assets/instagram.png') 
                },
                { 
                    name: 'TikTok', 
                    link: 'https://www.tiktok.com/@templo.edem', 
                    icon: require('@/assets/tik-tok.png') 
                },
                { 
                    name: 'YouTube', 
                    link: 'https://www.youtube.com/@temploedem8594', 
                    icon: require('@/assets/youtube.png') 
                },
                { 
                    name: 'login', 
                    link: '#', 
                    icon: require('@/assets/login.png') 
                }
            ]
        };
    },
    methods: {
        openLogin() {
            console.log('Abrindo modal de login');
            this.loginDialog = true;
            this.$nextTick(() => {
                if (this.$refs.usernameInput) {
                    this.$refs.usernameInput.focus();
                }
            });
        },
        closeLogin() {
            console.log('Fechando modal de login');
            this.loginDialog = false;
            this.loginData.login = '';
            this.loginData.password = '';
        },
        async handleLogin() {
            console.log('Processando login:', this.loginData);
            this.loading = true;
            
            try {
                const loginUrl = process.env.VUE_APP_VITE_API_URL + "/login"; //import.meta.env.VITE_LOGIN_URL;
                const loginTokenUrl = process.env.VUE_APP_VITE_API_URL + "/verifyToken"; //import.meta.env.VITE_LOGIN_TOKEN;

                // Chamada de login
                const loginResponse = await fetch(loginUrl, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(this.loginData),
                });

                const loginResult = await loginResponse.json();

                if (loginResult.error) {
                this.$emit('alertMessage', loginResult.error);
                this.loading = false;
                return;
                }
                // const data = await JSON.parse(JSON.stringify(loginResult));
                // const token = data.token;
                // const shorToken = data.shorToken;
                // const page = data.page;
                console.log("loginResult", loginResult);
                //console.log("Data", data);
                
                const { token, shortToken, page } = loginResult;
                localStorage.setItem('token', token);
                console.log("ShortToken1: ", shortToken);
                console.log("ShortToken2: ", loginResult.shortToken);
                // Chamada para obter dados do usuário
                const userResponse = await fetch(loginTokenUrl, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({ token: shortToken })
                });

                if (!userResponse.ok) {
                localStorage.removeItem('token');
                this.$emit('alertMessage', 'Erro ao obter dados do usuário. Por favor, faça login novamente.');
                this.loading = false;
                return;
                }

                const userResult = await userResponse.json();
                localStorage.setItem('user', JSON.stringify(userResult));

                // REDIRECIONAMENTO CORRIGIDO - Passa o token via URL
                const redirectUrl = new URL(process.env.VUE_APP_VITE_DASHBOARD_URL + "/login");
                console.log("redirectUrl", redirectUrl);
                console.log("token", token);
                redirectUrl.searchParams.set('token', shortToken);
                redirectUrl.searchParams.set('redirect', page); // página destino
                window.location.href = redirectUrl.toString();

            } catch (error) {
                console.error('Erro no login:', error);
                this.$emit('alertMessage', 'Não foi possível se conectar com o servidor. Tente novamente mais tarde.');
                this.loading = false;
            }
        }
    }
};
</script>

<style scoped>

.nav-social {
    display: -webkit-inline-box;
    padding: 0.8vi 1vi;
    cursor: pointer;
    font-family: 'Abhaya Libre';
    font-weight: bold;
    font-size: 2vi;
}

.nav-social .social-item {
    margin: 0 10px;
}

.nav-social .social-item img {
    width: 2vi;
    height: 2vi;
    transition: transform 0.3s ease;
}

.nav-social .social-item img:hover {
    transform: scale(1.1);
}

/* Modal de Login */
.login-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 10000;
}

.login-modal {
    background: white;
    padding: 20px;
    border-radius: 8px;
    width: 350px;
    max-width: 90vw;
    box-shadow: 0 4px 15px rgba(0, 0, 0, 0.3);
    position: relative;
    z-index: 10001;
}

.login-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
    border-bottom: 1px solid #eee;
    padding-bottom: 10px;
}

.login-header h3 {
    margin: 0;
    color: #333;
    font-family: 'Abhaya Libre';
}

.close-btn {
    background: none;
    border: none;
    font-size: 24px;
    cursor: pointer;
    color: #999;
    padding: 0;
    width: 30px;
    height: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.close-btn:hover {
    color: #333;
}

.login-content {
    margin-top: 15px;
}

.form-group {
    margin-bottom: 15px;
}

.form-group input {
    width: 100%;
    padding: 10px;
    border: 1px solid #ddd;
    border-radius: 4px;
    font-size: 14px;
    box-sizing: border-box;
}
.align-center {
    text-align: center;
}

.form-group input:focus {
    outline: none;
    border-color: #f4cf5e;
}

.btn-login {
    width: 100%;
    padding: 12px;
    background-color: #4CAF50;
    color: white;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    font-size: 16px;
    margin-top: 10px;
}

.btn-login:hover {
    background-color: #45a049;
}

.btn-login:disabled {
    background-color: #cccccc;
    cursor: not-allowed;
}

@media(max-width: 922px){
    .nav-social .social-item img {
        width: 5vi;
        height: 5vi;
        transition: transform 0.3s ease;
    }
}
</style>